/** 登录/注册请求附带的客户端信息 */
export function getClientInfo() {
  const userAgent = navigator.userAgent;
  let clientSystem = "Unknown";

  if (userAgent.includes("Windows")) clientSystem = "Windows";
  else if (userAgent.includes("Mac")) clientSystem = "MacOS";
  else if (userAgent.includes("Linux")) clientSystem = "Linux";
  else if (userAgent.includes("Android")) clientSystem = "Android";
  else if (userAgent.includes("iOS") || userAgent.includes("iPhone"))
    clientSystem = "iOS";

  const storedId = localStorage.getItem("client_id");
  const clientId = storedId || "web";

  return {
    clientId,
    clientName: "Web Browser",
    clientSystem,
  };
}
